module.exports = __webpack_public_path__ + "img/vk.41cdafe.svg?v=1753181944267";